import type {LightboxSlide} from './types';

export const isDocumentSrc = (src: string) => {
  const [url] = src.split('?');

  if (!url) {
    return false;
  }

  const isDocument = /\.(?:pdf|docx?|xlsx?|pptx?|txt|csv|rtf|html?)$/i.test(
    url,
  );

  return isDocument;
};

export const isHtmlSrc = (src: string) => {
  const [url] = src.split('?');

  if (!url) {
    return false;
  }

  const isHtml = /\.html?$/i.test(url);

  return isHtml;
};

const isImageSrc = (src: string) => {
  const [url] = src.split('?');

  if (!url) {
    return false;
  }

  const isImage = /\.(?:jpe?g|png|gif|svg)$/i.test(url);

  return isImage;
};

export const getSlideType = (src: string): LightboxSlide['type'] => {
  switch (true) {
    case isImageSrc(src):
      return 'image';
    case isDocumentSrc(src):
      return 'document';
    default:
      return 'htmlContent';
  }
};
